export const state = () => ({
  // The current Country the user has selected.  Defaults to US
  selected_country: 'us',
  // The current Currency being used, defaulting to USD
  selected_currency: 'usd',
  // The Country detected by our system.  If available, we can prompt the user to switch to it
  detected_country: null,
})

export const actions = {
  /**
   * Performs geo detection and commits the resulting code to detected_country
   */
  async detectUserRegion({ commit }) {
    const response = await this.$api.get(
      'https://app.logo.com/api/v2/geo/locate'
    )

    commit('setDetectedCountry', response.country_code)
  },
}
export const mutations = {
  /**
   *
   * @param {*} state The Vuex state
   * @param {string} region The 2 letter country code
   */
  setDetectedCountry(state, country) {
    state.detected_country = country
  },
}
